/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides all nessesary aria-* attributes to create valid expanded button state
 */
export function ariaExpanded() {
    return (target) => target.addInitializer((instance) => new AriaExpandedController(instance));
}
export class AriaExpandedController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    hostUpdated() {
        if (this.host.expanded !== null && this.host.expanded !== undefined) {
            this.host.ariaExpanded = this.host.expanded ? 'true' : 'false';
        }
        if (this.host.readonly) {
            this.host.ariaExpanded = null;
        }
    }
}
